export default{ 
api_url : 'https://copy.mynt.in/',
api_uat_url : 'https://copy.mynt.in/uat',
// api_url : 'http://192.168.5.192:5001', 
mynturl: "https://go.mynt.in/NorenWClientTP/",
mynts: "https://go.mynt.in/",

 
mynturluar: "https://uat.mynt.in/NorenWClientTP/",
myntsuat: "https://uat.mynt.in/",

// qrurl: 'http://192.168.5.192:5001'
// qrurl: 'https://copy.mynt.in/'

// api_url : 'https://zsync.zebull.in/zebu' 

}
// https://zsync.zebull.in
// http://192.168.5.162:7000/invezt